import { Logo } from '@zuruflex/ui';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';
import { SignInPage } from '../pages/SignInPage.js';

/**
 * The gate in front of the whole dashboard.
 *
 * Sign-in is rendered in place rather than redirected to, so the URL
 * someone followed survives being asked to sign in — they land on the page
 * they were after, not on the dashboard index.
 */
export function RequireAuth() {
  const { user, isRestoring } = useAuth();
  const { t } = useTranslation('common');

  /**
   * Exchanging the stored refresh token takes a round trip. Flashing the
   * sign-in form during it would make every reload look like a sign-out.
   */
  if (isRestoring) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-surface">
        <Logo variant="mark" className="size-8 animate-pulse" />
        <p className="text-sm text-text-muted">{t('state.loading')}</p>
      </div>
    );
  }

  return user ? <Outlet /> : <SignInPage />;
}
